@if (items().length === 0) {
  <article class="ui-stock-card-list__empty">
    <p>{{ emptyMessage() | uiLabelTranslate }}</p>
  </article>
} @else {
  <section class="ui-stock-card-list">
    @for (category of items(); track category.id) {
      <ui-card>
        <header class="ui-stock-card-list__card-header">
          <div class="ui-stock-card-list__category-heading">
            <span class="ui-stock-card-list__level-label">Category</span>
            <h2 class="ui-stock-card-list__category-title">{{ category.name }}</h2>
            <div class="ui-stock-card-list__summary">
              <span>{{ categoryProductCount(category) }} products</span>
              <span>{{ categoryVariantCount(category) }} variants</span>
              <span>{{ categoryTotalQuantity(category) }} total stock</span>
            </div>
          </div>
          <div class="ui-stock-card-list__card-actions">
            <ui-button
              variant="ghost"
              size="sm"
              [icon]="isExpanded(category.id) ? 'expand_less' : 'expand_more'"
              [ariaLabel]="isExpanded(category.id) ? 'Collapse category' : 'Expand category'"
              (click)="toggleCategory(category.id)"
            ></ui-button>
            @if (showCategoryEdit()) {
              <div class="ui-stock-card-list__action ui-stock-card-list__action--edit">
                <ui-button variant="ghost" size="sm" icon="edit" ariaLabel="Edit category" (click)="requestCategoryEdit(category)"></ui-button>
              </div>
            }
            @if (showCategoryRemove()) {
              <div class="ui-stock-card-list__action ui-stock-card-list__action--delete">
                <ui-button variant="ghost" size="sm" icon="delete" ariaLabel="Remove category" (click)="requestCategoryRemove(category)"></ui-button>
              </div>
            }
          </div>
        </header>
        @if (isExpanded(category.id)) {
          <div class="ui-stock-card-list__card-body">
            <div class="ui-stock-card-list__carousel-header">
              <span class="ui-stock-card-list__level-label">Products & Variants</span>
              <div class="ui-stock-card-list__carousel-actions">
                <ui-button variant="ghost" size="sm" icon="chevron_left" ariaLabel="Previous products" (click)="scrollProducts(category.id, 'previous')"></ui-button>
                <ui-button variant="ghost" size="sm" icon="chevron_right" ariaLabel="Next products" (click)="scrollProducts(category.id, 'next')"></ui-button>
              </div>
            </div>

            <div #productRail class="ui-stock-card-list__product-rail" [attr.data-category-id]="category.id">
              @for (product of category.products; track product.id) {
                @if (product.isCashProduct) {
                  <section class="ui-stock-card-list__product">
                    <header class="ui-stock-card-list__product-header">
                      <span class="ui-stock-card-list__level-label">Product</span>
                      <p class="ui-stock-card-list__product-title">{{ product.name }}</p>
                    </header>
                    <article class="ui-stock-card-list__variant-row">
                      <div class="ui-stock-card-list__variant-copy">
                        <span class="ui-stock-card-list__level-label ui-stock-card-list__level-label--variant">Quantity</span>
                      </div>
                      <div class="ui-stock-card-list__variant-qty-wrap">
                        <span class="ui-stock-card-list__variant-qty">{{ product.totalQuantity ?? 0 }}</span>
                      </div>
                    </article>
                  </section>
                } @else {
                  <section class="ui-stock-card-list__product">
                    <header class="ui-stock-card-list__product-header">
                      <span class="ui-stock-card-list__level-label">Product</span>
                      <p class="ui-stock-card-list__product-title">{{ product.name }}</p>
                      @if (showProductStatus() && product.status && product.statusLabel) {
                      <div class="ui-stock-card-list__product-summary">
                        <ui-badge [label]="product.statusLabel" [tone]="badgeTone(product.status)"></ui-badge>
                        <div class="ui-stock-card-list__product-metrics">
                          <span>{{ product.totalQuantity ?? 0 }} {{ 'uiLabels.total' | uiLabelTranslate }}</span>
                          <span>{{ 'stockThresholds.table.threshold' | uiLabelTranslate }} {{ product.threshold ?? 0 }}</span>
                        </div>
                      </div>
                      }
                    </header>

                    <div class="ui-stock-card-list__variant-list">
                      @for (variant of product.variants; track variant.id) {
                        <article class="ui-stock-card-list__variant-row" [class.ui-stock-card-list__variant-row--with-status]="showVariantStatus() && !!variant.status && !!variant.statusLabel">
                          <div class="ui-stock-card-list__variant-copy">
                            <span class="ui-stock-card-list__level-label ui-stock-card-list__level-label--variant">Variant</span>
                            <p class="ui-stock-card-list__variant-name">{{ variant.name }}</p>
                          </div>
                          @if (showVariantStatus() && variant.status && variant.statusLabel) {
                            <div class="ui-stock-card-list__variant-status">
                              <ui-badge [label]="variant.statusLabel" [tone]="badgeTone(variant.status)"></ui-badge>
                            </div>
                          }
                          <div class="ui-stock-card-list__variant-qty-wrap">
                            <span class="ui-stock-card-list__variant-qty">{{ variant.quantity }}</span>
                          </div>
                        </article>
                      }
                    </div>
                  </section>
                }
              }
            </div>
          </div>
        }
      </ui-card>
    }
  </section>
}
